import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useEffect } from 'react';
import { useSearchContext, DEFAULT_MIN_QUERY_LENGTH } from '../../../searchContext/SearchContextProvider.js';
import localize from '../../../util/localize.js';
import { SearchResultsDisplay } from '../SearchResultsDisplay.js';
import { createCtx } from '../../../util/createCtx.js';
import { useScreenClass, Box, tokens, VisuallyHidden, GridContainer, List } from '@vp/swan';
import { displayConfigurationDecider } from './searchBarDisplayConfigurations.js';

var _createCtx = createCtx(),
  _createCtx2 = _slicedToArray(_createCtx, 2),
  useFlyoutContext = _createCtx2[0],
  FlyoutContext = _createCtx2[1];
var SearchFlyout = function SearchFlyout(_ref) {
  var veilEnabled = _ref.veilEnabled,
    _ref$minQueryLen = _ref.minQueryLen,
    minQueryLen = _ref$minQueryLen === void 0 ? DEFAULT_MIN_QUERY_LENGTH : _ref$minQueryLen,
    siteAnalyticsEventName = _ref.siteAnalyticsEventName,
    _ref$getSiteAnalytics = _ref.getSiteAnalyticsQueryString,
    getSiteAnalyticsQueryString = _ref$getSiteAnalytics === void 0 ? function (query) {
      return "swsquery=".concat(query, "&querycat=search_dropdown");
    } : _ref$getSiteAnalytics;
    _ref.seeAllText;
    var applicationName = _ref.applicationName,
    resultDisplayConfiguration = _ref.resultDisplayConfiguration;
  var _useSearchContext = useSearchContext(),
    results = _useSearchContext.results,
    query = _useSearchContext.query,
    isFlyoutExpanded = _useSearchContext.isFlyoutExpanded,
    setIsFlyoutExpanded = _useSearchContext.setIsFlyoutExpanded,
    isFocused = _useSearchContext.isFocused,
    selectedResult = _useSearchContext.selectedResult,
    instanceId = _useSearchContext.instanceId,
    locale = _useSearchContext.locale;
  var screenClass = useScreenClass();
  var flyoutPaddingPixels = Object.keys(results).some(function (taxonomy) {
    return results[taxonomy].length;
  }) && screenClass === 'xs' ? 3 : 0;
  useEffect(function () {
    setIsFlyoutExpanded(Object.keys(results).length > 0 && query.length >= minQueryLen);
  }, [setIsFlyoutExpanded, results, query]);
  var effectiveDisplayConfiguration = _objectSpread2(_objectSpread2({}, displayConfigurationDecider(applicationName)), resultDisplayConfiguration);
  var numberOfResults = results ? Object.keys(results).reduce(function (acc, taxonomy) {
    return acc + results[taxonomy].length;
  }, 0) : 0;
  numberOfResults = Math.min(numberOfResults, effectiveDisplayConfiguration.maxResults);
  return numberOfResults > 0 && /*#__PURE__*/React__default.createElement(FlyoutContext, {
    value: {
      siteAnalyticsEventName: siteAnalyticsEventName,
      analyticsQueryString: getSiteAnalyticsQueryString(query)
    }
  }, (isFocused || selectedResult !== 0) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, veilEnabled && isFlyoutExpanded && /*#__PURE__*/React__default.createElement(Box, {
    className: "search-flyout-veil",
    mt: 2,
    style: {
      backgroundColor: tokens.SwanSemColorBrandMidnight,
      opacity: 0.85
    },
    z: tokens.SwanSemZIndexOverlay
  }), /*#__PURE__*/React__default.createElement(Box, {
    id: "siteSearchResultsListBox-".concat(instanceId),
    className: "search-flyout-wrapper",
    paddingTop: flyoutPaddingPixels,
    width: "100%"
  }, /*#__PURE__*/React__default.createElement(VisuallyHidden, {
    id: "siteHeaderSearchFlyoutLabel-".concat(instanceId),
    "aria-live": "polite",
    "aria-atomic": "true",
    role: "status"
  }, results && Object.keys(results).length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, localize('searchFlyoutLabel', locale).replace('{{numberOfResults}}', numberOfResults))), /*#__PURE__*/React__default.createElement("div", {
    className: "search-flyout"
  }, /*#__PURE__*/React__default.createElement(GridContainer, {
    id: "siteHeaderSearchFlyout",
    className: "search-flyout-drop-down",
    display: isFlyoutExpanded ? 'block' : 'none',
    style: {
      borderRadius: tokens.SwanSemBorderRadiusStrong
    },
    marginTop: {
      sm: 2,
      md: 2,
      lg: 2,
      xl: 2,
      xs: 0
    },
    bgc: 'standard',
    p: 0
  }, /*#__PURE__*/React__default.createElement(List, {
    role: "listbox",
    skin: "minimal",
    "aria-label": localize('searchResults', locale),
    mb: 6
  }, results && /*#__PURE__*/React__default.createElement(SearchResultsDisplay, {
    resultDisplayConfiguration: _objectSpread2(_objectSpread2({}, displayConfigurationDecider(applicationName)), resultDisplayConfiguration)
  })))))));
};

export { FlyoutContext, SearchFlyout as default, useFlyoutContext };
//# sourceMappingURL=SearchFlyout.js.map
